import { SuperBannerCMSConfiguration } from "./SuperBannerCMSConfiguration";
import { SuperBannerItem, SuperBannerJackpotItem } from "../SuperBannerItem";
export class SuperBannerConfiguration extends SuperBannerCMSConfiguration {
    constructor(source, clientIncludeInManager) {
        super(source);
        this.SuperBannerItems = [];
        /* istanbul ignore next */
        if (source.SuperBannerItems) {
            for (let index = 0; index < source.SuperBannerItems.length; index++) {
                let item = this.GetItem(source.SuperBannerItems[index], clientIncludeInManager);
                this.SuperBannerItems.push(item);
            }
        }
    }
    GetItem(data, clientIncludeInManager) {
        if (data.JackpotId) {
            return new SuperBannerJackpotItem(data, clientIncludeInManager);
        }
        return new SuperBannerItem(data, clientIncludeInManager);
    }
}
//# sourceMappingURL=SuperBannerConfiguration.js.map